

import React from 'react';
import { IconProps } from '../../types/types';

const ExportIcon: React.FC<IconProps> = ({ size = '20', color = '#1E1E1E' }) => (
<svg width={size} height={color} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.2334 14.5815L10.1001 16.7148L7.96673 14.5815" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.0996 8.18516L10.0996 16.6602" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.667 10C16.667 6.31667 14.167 3.33333 10.0003 3.33333C5.83366 3.33333 3.33366 6.31667 3.33366 10" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default ExportIcon;